// extracted by mini-css-extract-plugin
module.exports = {"container":"contact-module--container--1JMah","text":"contact-module--text--iERf5","button":"contact-module--button--2QweJ"};